import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import shiftService from '../services/shiftService';
import { useLocation } from "react-router-dom";
const ShiftContext = createContext(null);

export function ShiftProvider({ children }) {
  const location = useLocation();
  const [activeShift, setActiveShift] = useState(null);
  const [loading, setLoading] = useState(true);
  const [shiftEnabled, setShiftEnabled] = useState(null); // null = loading
  const [denominationEnabled, setDenominationEnabled] = useState(false);

  const fetchActiveShift = useCallback(async () => {
    try {
      const res = await shiftService.getActiveShift();
      setActiveShift(res || null);
    } catch {
      setActiveShift(null);
    } finally {
      setLoading(false);
    }
  }, []);

  // On mount: fetch config first, then conditionally fetch active shift
  useEffect(() => {
  if (location.search.includes("reset-password")) {
  setLoading(false);
  return;
}
    const init = async () => {
      try {
        const configRes = await shiftService.getShiftConfig();
        const enabled = configRes?.shiftEnabled === true;
        setShiftEnabled(enabled);
        setDenominationEnabled(configRes?.denominationEnabled === true);

        if (enabled) {
          await fetchActiveShift();
        } else {
          setActiveShift(null);
          setLoading(false);
        }
      } catch {
        setShiftEnabled(false);
        setActiveShift(null);
        setLoading(false);
      }
    };
    init();
  }, [fetchActiveShift, location.search]);

  const startShift = useCallback(async (openingCash) => {
    const res = await shiftService.startShift(openingCash);
    setActiveShift(res || null);
    return res;
  }, []);

  const endShift = useCallback(async (actualCash, notes, denomination) => {
    if (!activeShift?.id) return;
    const res = await shiftService.endShift(activeShift.id, { actualCash, notes, denomination });
    setActiveShift(null);
    return res;
  }, [activeShift]);

  const refreshShift = useCallback(async () => {
    await fetchActiveShift();
  }, [fetchActiveShift]);

  const hasActiveShift = !!activeShift;

  return (
    <ShiftContext.Provider
      value={{
        activeShift,
        hasActiveShift,
        loading,
        shiftEnabled,
        denominationEnabled,
        startShift,
        endShift,
        refreshShift,
      }}
    >
      {children}
    </ShiftContext.Provider>
  );
}

export function useShift() {
  const context = useContext(ShiftContext);
  if (!context) {
    throw new Error('useShift must be used within a ShiftProvider');
  }
  return context;
}

export default ShiftContext;
